export default __webpack_public_path__ + "d70ac617da260e794fc13031e2940486.png";